import{useContext as r}from'react';import{MediaMatchContext as o}from'./MediaMatchProvider.js';const t=()=>r(o);export{t as useViewport};
